import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import { PageSectionTwoColumnsImageFullwidth } from 'components/page/sections/page-section-two-columns-image-fullwidth';
import { SectionContentLinkList } from 'components/section-content-link-list';
import { SectionContentLinkListIdSix } from 'components/section-content-link-list/section-content-link-list.enums';

export const TabSixContainer: React.FC = () => {
  const list = [
    {
      id: SectionContentLinkListIdSix.WhatHappensWhenYouDeleteYourAccount,
      text: sections.tabSixSection.tab.contents.item1(),
    },
    {
      id: SectionContentLinkListIdSix.ConnectingYouAroundTheWorld,
      text: sections.tabSixSection.tab.contents.item2(),
    },
  ];
  const props = {
    columnLeft: {
      title: sections.tabSixSection.tab.title(),
      subTitle: sections.tabSixSection.tab.text(),
    },
    columnRight: {
      title: sections.tabSixSection.tab.contents.title(),
      content: <SectionContentLinkList list={list} />,
    },
    image: {
      src: `${CdnImagePath}/assets/tab-06/tab-06-01.jpg`,
      objectPosition: '50% 33%',
      inlinePosition: 'start',
    },
  };

  return <PageSectionTwoColumnsImageFullwidth {...props} />;
};
